module.exports = __webpack_public_path__ + "static/img/Thon-Maker.51ac2e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thon-Maker.jpg
// module id = BbMk
// module chunks = 1